import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { Popover } from "@mui/material";
import Badge from "@mui/material/Badge";
import { ReactNode } from "react";
import StyledButtonV2 from "./app/StyledButtonV2";

interface GlobalFilterProps {
  starIcon?: ReactNode;
  anchorEl: HTMLElement | null;
  setAnchorEl: React.Dispatch<React.SetStateAction<HTMLElement | null>>;
  children: ReactNode;
  activeFilterCount?: number;
}

const buttonSx = {
  height: 26,
  borderRadius: "4px",
  fontSize: 12,
  backgroundColor: "#fff",
  borderColor: "#104E84",
  color: "#104E84",
  "& .MuiButton-startIcon svg": { color: "#104E84" },
  fontWeight: 400,
};

/**
 *
 * `This is helper component`
 *
 * @param anchorEl: HTMLElement | null
 * @param setAnchorEl: Dispatcher <HTMLElement | null>
 *
 * @returns it return a `WRAPPER` -component
 *
 * on top of this we can customize the filter component as per requirement
 *
 * @author rajkumar rathod
 */
const GlobalFilter = ({
  starIcon,
  anchorEl,
  setAnchorEl,
  children,
  activeFilterCount,
  // buttonSx,
}: GlobalFilterProps) => {
  const open = Boolean(anchorEl);
  const close = () => setAnchorEl(null);

  return (
    <>
      <FilterCountBadge
        activeFilterCount={activeFilterCount}
        starIcon={starIcon}
        setAnchorEl={setAnchorEl}
      />
      <Popover
        open={open}
        onClose={close}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {children}
      </Popover>
    </>
  );
};

export default GlobalFilter;

const FilterCountBadge = ({
  activeFilterCount,
  starIcon,
  setAnchorEl,
}: {
  activeFilterCount: number | undefined;
  starIcon: ReactNode;
  setAnchorEl?: React.Dispatch<React.SetStateAction<HTMLElement | null>>;
}) => {
  return (
    <Badge
      badgeContent={
        activeFilterCount && activeFilterCount > 0 ? activeFilterCount : null
      }
      color="error"
      overlap="circular"
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      <StyledButtonV2
        variant="outlined"
        sIcon={
          starIcon ||
          (activeFilterCount && activeFilterCount > 0 ? (
            <FilterAltIcon />
          ) : (
            <FilterAltOutlinedIcon />
          ))
        }
        label={`Filters`}
        onClick={(e) => setAnchorEl?.(e.currentTarget)}
        sx={{ px: "18px", ...(buttonSx as object) }}
      />
    </Badge>
  );
};
